<template>
    <section id="saving-content">
        <div class="container">
            <div class="content">
                <span class="eyebrow-page omnes fw-semibold text-orange"
                    >Patient Savings</span
                >
                <h1 class="gtitle fw-semibold savings-title">
                    Regardless of coverage, commercially insured patients can save on JORNAY PM prescriptions
                </h1>
            </div>

            <div class="content img-container">
                <!-- <img
                    class="d-none d-lg-block"
                    src="../../assets/img/savings/savings.png"
                    alt="Graphic showing several saving tiers, including $0, $25, and $75"
                />
                <img
                    class="d-block d-lg-none"
                    src="../../assets/img/savings/savings-mobile.png"
                    alt="Graphic showing several saving tiers, including $0, $25, and $75"
                /> -->
                <img
                    src="../../assets/img/JNY-Copay-Card.png"
                    alt=""
                    width="310"
                    height="320"
                />
            </div>
        </div>

        <div class="page-container savings-box-container">
            <p>
                Savings are for up to 30 capsules per prescription. For
                additional Terms and Conditions visit the <a class="fw-regular patient-page" href="https://www.jornaypm.com/savings" target="_blank">JORNAY PM Savings Page</a>.
            </p>

            <p class="savings-note">
                <span>*</span>
                Please note that the savings program is only for eligible
                patients with commercial insurance in the U.S.
            </p>
        </div>
    </section>
</template>

<script>
export default {
    components: {},
};
</script>
